export const baseUrl = "https://mf.amanmicrofinance.com/api";   //prod
// export const baseUrl = "https://stage.amanmicrofinance.com/api";   //stage
export const altsapiBaseUrl = "https://altsapi.amanmfapp.com/Uniparticle/api";
export const stageBaseUrl = "https://stage.amanmicrofinance.com/api";
